import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundOriginalPayGatePaymentResponse {
  @observable
  terminalId!: string;

  @observable
  @Type(() => Date)
  authorizedAt!: Date;

  @observable
  invoiceNumber!: string;

  @observable
  paidAmount!: number;

  @observable
  arn!: string;

  @observable
  variableSymbol?: number;
}
